import { render, staticRenderFns } from "./IconGear.vue?vue&type=template&id=926c835e&functional=true&"
import script from "./IconGear.vue?vue&type=script&lang=js&"
export * from "./IconGear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports